/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, SyntheticEvent, useEffect, CSSProperties, useRef } from 'react';
import { Formik, Field } from 'formik';
import { connect, useSelector } from 'react-redux';
import { iRootState } from '../../../../store';
import { format } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';
import EditCapitalizationModal from '../../../capitalization/components/edit-capitalization-modal/Modal';
import {
  Modal,
  Button,
  Form,
  Table,
  Icon,
  SemanticCOLORS,
  TextArea,
  Popup,
  Grid,
  Dimmer,
  Loader,
  Dropdown
} from 'semantic-ui-react';
import ButtonComponent from '../../../../components/Button';
import styled from 'styled-components';
import { ModalProps } from '../../../../components/types';
import { BondInsuranceAnalysisStatusEnum } from '../../../../enums/bond-insurance-analysis-status.enum';
import { analysisFileIdentifiers, statusOptions, isPottencialLowerLimitPreapproved, getPreapprovedStatusLabel } from '../../types';
import StatusDropdown from '../../../../components/StatusDropdown';
import Input from '../../../../components/Input';
import {
  updateAnalysis,
  sendAnyLetter,
  downloadLetter
} from '../../../../services/bond-insurance';
import {
  successNotification,
  dangerNotification,
  warningNotification
} from '../../../../services/notification';
import { IconText } from '../../../../components/IconText';
import {
  formatAmount,
  maskCpfOrCnpj,
  maskMoney,
  unmaskMoney
} from '../../../../services/masks';
import { CalculationModeEnum } from '../../../../enums/calculation-mode.enum';
import { UserState } from '../../../../types/UserState';
import {
  BondInsuranceAnalysisForGetBondInsurancesResponseDTO,
  BondInsuranceForGetBondInsurancesResponseDTO,
  BondInsurancePropertyForGetBondInsurancesResponseDTO,
  NaturalTenantForGetBondInsurancesResponseDTO
} from '../../../../dtos/bond-insurance-list/get-bond-insurances-response.dto';
// import { FileAttachmentProps } from '../../../../components/UploadFiles';
import PottencialHireProposalModal from './components/PottencialHire/ModalHireProposal';
import { InsurersCodeEnum } from '../../../../enums/insurers-code.enum';
import GeneralHireProposalModal from './components/GeneralHire/ModalHireProposal';
import CancelModal from './components/CancellationModal/CancelModal';
import LogTable from './components/LogModal/LogTable';
import { PersonTypesEnum } from '../../../../enums/person-types.enum';
import { UserRolesEnum } from '../../../../enums/user-roles.enum';
import GeneralReanalysisModal from './components/ReanalysisModal/Modal';
import { CalculationTypeEnum } from '../../../../enums/calculation-type.enum';
import { AnalysisAssuranceEnum } from '../../../../enums/analysis-assurance.enum';

import HirePortoModal from './components/PortoEssencialHire/ModalHireProposal';
import { EstateForGetEstatesResponseDTO } from '../../../../dtos/estate/estate-for-get-estates-response.dto';
import GaranttiHireProposalModal from './components/GaranttiHire/ModalHireProposal';
import moment from 'moment';
import HirePortoTradicionalModal from './components/PortoTradicionalHire/ModalHireProposal';
import { PurposesEnum } from '../../../../enums/purposes.enum';
import AuthorizationContainer from '../../../../components/AuthorizationContainer';
import { ActionEnum } from '../../../../enums/authz-action.enum';
import { FeatureEnum } from '../../../../enums/authz-feature.enum';
import RegisterBiometricsModal from './components/RegisterBiometricsModal';
import EditPlansModal from './components/EditPlansModal';
import SegimobHireProposalModal from './components/SegimobHire/ModalHireProposal';
import IconButton from '../../../../components/IconButton';
import AlpopBanner from './components/AlpopBanner';
import OtherSolutionsBanner from './components/OtherSolutionsBanner';
import { BorderTop } from 'styled-icons/boxicons-regular';
import { BondInsuranceMainInfoDetails } from '../BondInsuranceMainInfoDetails';
import ReactToPrint from 'react-to-print';
import { AvailableBrokersAndEstatesState } from '../../../../store/types/temp-types';
import { BondInsurancePropertyDetails } from '../BondInsurancePropertyDetails';
import { BondInsuranceNaturalTenantDetails } from '../BondInsuranceNaturalTenantDetails';
import { BondInsuranceLegalTenantDetails } from '../BondInsuranceLegalTenantDetails';

export const ConfirmationModalContent = styled(Modal.Content)`
  line-height: 1.8rem;
  div:last-child:not(:first-child) {
    font-weight: bold;
  }
`;

const InfoContainer = styled.div`
  width: 100%;

  background-color: #f7f0eb;
  padding: 1rem;
  border-radius: 2px;

  /* display: flex; */
  /* flex-direction: column; */

  /* > div {
    display: flex;
    gap: 1rem;
    margin-bottom: 0.35rem;

    > div {
      flex: 1;
    }
  } */
`;

const RowButtons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  width: 100%;
`;

const PrintedContainer = styled.div`
  @media print {
    @page {
      margin-top: 1cm;
      margin-bottom: 0.5cm;
      margin-left: 0.5cm;
      margin-right: 0.5cm;
    }

    .payment-container {
      page-break-after: always;
    }
  }
`;

export type AnalysisDetailsModal = {
  initialParcel: number[];
  bondInsurance: BondInsuranceForGetBondInsurancesResponseDTO;
  analysisDetails: BondInsuranceAnalysisForGetBondInsurancesResponseDTO[];
  naturalTentant: NaturalTenantForGetBondInsurancesResponseDTO;
  validityMonths: number;
  user: UserState;
  totalAmount: number;
  rentValue: number;
  calculationMode: CalculationModeEnum;
  calculationType?: CalculationTypeEnum;
  estate?: EstateForGetEstatesResponseDTO;
  property: BondInsurancePropertyForGetBondInsurancesResponseDTO;
  bondInsuranceId: string;
  externalBondInsuranceAnalysisId?: string;
  canEdit: boolean;
  cleanIdReferences?: () => void;
  availableBrokersAndEstates: AvailableBrokersAndEstatesState;
  open?: boolean;
  onClose?: React.ReactEventHandler<{}>;
} & ModalProps;

const toCamel = (s: string) => {
  return s.replace(/([-_][a-z])/gi, $1 => {
    return $1.toUpperCase().replace('-', '').replace('_', '');
  });
};

const isArray = function (a: any) {
  return Array.isArray(a);
};

const isObject = function (o: any) {
  return o === Object(o) && !isArray(o) && typeof o !== 'function';
};

const keysToCamel = function (o: any): any {
  if (isObject(o)) {
    const n = {} as any;

    Object.keys(o).forEach(k => {
      n[toCamel(k)] = keysToCamel(o[k]);
    });

    return n;
  } else if (isArray(o)) {
    return o.map((i: any) => {
      return keysToCamel(i);
    });
  }

  return o;
};

const AnalysisProgressModal = (props: AnalysisDetailsModal): JSX.Element => {
  const { canEdit } = props;
  const lenderInsuranceEnabled = useSelector(
    (state: iRootState) =>
      state.availableBrokersAndEstates.lenderInsuranceEnabled ?? false
  );
  const [isOpen, setIsOpen] = useState<boolean>(props.open || false);
  const [hasChange, setHasChange] = useState(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [analysisChanged, setAnalysisChanged] = useState<number[]>([]);
  const [openHireProposalModal, setOpenHireProposalModal] = useState(false);
  const [loadingPottencialStatus, setLoadingPottencialStatus] = useState(false);
  const [showCapitalizationModal, setShowCapitalizationModal] = useState(false);
  const [externalOpenEditCapitalizationModal, setRxternalOpenEditCapitalizationModal] =
    useState(false);
  const [isRequired, setIsRequired] = useState(false);

  const [selectedAnalysisIndex, setSelectedAnalysisIndex] = useState<number | null>(null);
  const [openEditPlansModal, setOpenEditPlansModal] = useState<boolean>(false);

  const [displayTab, setDisplayTab] = useState<'resultados' | 'detalhes' | 'logs'>(
    'resultados'
  );

  const { header, trigger, callback, user } = props;
  const isEstateQuotationUser = user.role === UserRolesEnum.estateQuotation;

  const {
    initialParcel,
    analysisDetails,
    validityMonths,
    totalAmount,
    rentValue,
    calculationMode,
    naturalTentant,
    estate,
    property,
    bondInsuranceId,
    bondInsurance,
    availableBrokersAndEstates
  } = props;

  const closeEditPlansModal = (): void => {
    setSelectedAnalysisIndex(null);
    setOpenEditPlansModal(false);
  };

  const allRefused = analysisDetails.every(
    (analysis: BondInsuranceAnalysisForGetBondInsurancesResponseDTO) => {
      return analysis.status === BondInsuranceAnalysisStatusEnum.rejected;
    }
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const open = (): void => {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define

    if (bondInsurance.property.total_amount > 5000) {
      setShowCapitalizationModal(allRefused);
    }

    setIsOpen(true);
  };
  const close = (): void => {
    setIsOpen(false);

    if (props.onClose) {
      props.onClose({} as any);
    }
  };

  const street = bondInsurance.property.street || null;
  const number = bondInsurance.property.number || null;
  const complement = bondInsurance.property.complement || null;
  const city = bondInsurance.property.city || null;
  const uf = bondInsurance.property.state || null;

  const address = `${street ? street : ''}${number ? ', ' + number : ''}${
    complement ? ' ' + complement : ''
  }${city ? ' - ' + city : ''}${uf ? ' - ' + uf : ''}`;

  const tenant_name =
    bondInsurance.tenant_type === 'NATURAL'
      ? bondInsurance.natural_tenant.main_tenant_name
      : bondInsurance.legal_tenant.company;
  const tenant_document =
    bondInsurance.tenant_type === 'NATURAL'
      ? bondInsurance.natural_tenant.main_tenant_cpf
      : bondInsurance.legal_tenant.document;

  const analysisFormData: any[] = [];

  const getOffers = (insurer: string, insurerResponse: any) => {
    if (insurer === InsurersCodeEnum.Garantti) {
      if (!insurerResponse) {
        const garanttiAnalysis: any = bondInsurance.bond_insurance_analysis.find(
          analysis => analysis.insurer.code === InsurersCodeEnum.Garantti
        );
        const installmentValue = garanttiAnalysis?.value;
        const installments =
          garanttiAnalysis?.complete_values?.maximum_installments_amount;

        const offer = [
          {
            quantidadeParcela: installments,
            valorParcela: Number(installmentValue),
            nomeSeguro: 'CUSTOM',
            id: 'custom',
            lmi: garanttiAnalysis.used_lmi,
            residentialFee: Number(garanttiAnalysis.used_taxes) * 100,
            commercialFee: Number(garanttiAnalysis.used_taxes) * 100,
            rateCharge: false
          }
        ];

        return offer;
      } else {
        const offers = insurerResponse.map((item: any) => {
          return {
            quantidadeParcela: item.rent_months_count,
            valorParcela:
              bondInsurance.purpose === PurposesEnum.residential
                ? item.residentialfee_assurance_month_amount
                : item.commercialfee_assurance_month_amount,
            nomeSeguro: String(
              item.description ? item.description : item.plan_id
            ).toUpperCase(),
            planoSelecionado: item.plan_id,
            id: item.id,
            lmi: item.lmi,
            residentialFee: item.residential_fee,
            commercialFee: item.commercial_fee,
            rateCharge: item.flag_ratecharge === '1'
          };
        });

        const sortedOffers = offers.sort(
          (a: { valorParcela: number }, b: { valorParcela: number }) =>
            a.valorParcela - b.valorParcela
        );

        return sortedOffers;
      }
    }

    const sortedResponse = Array.isArray(insurerResponse)
      ? insurerResponse.sort(
          (a: { valor_parcela: number }, b: { valor_parcela: number }) =>
            a.valor_parcela - b.valor_parcela
        )
      : insurerResponse;

    // Filtrar produtos rejeitados para Pottencial
    if (insurer === InsurersCodeEnum.Pottencial && Array.isArray(sortedResponse)) {
      const rejectedStatuses = ['denied', 'refused', 'refusedbiometry', 'expired'];

      const filteredResponse = sortedResponse.filter((product: any) => {
        // Verificar status rejeitado
        const status = product.status?.toLowerCase() || '';
        const isRejected = rejectedStatuses.some(rejected => status.includes(rejected));

        // Verificar se tem valor válido
        const valorParcela = product.valorParcela || product.valor_parcela || 0;
        const hasValidValue = valorParcela > 0;

        // Retornar apenas produtos não rejeitados e com valor
        return !isRejected && hasValidValue;
      });

      console.log(
        `Pottencial: ${sortedResponse.length} produtos total, ${filteredResponse.length} produtos válidos`
      );
      return keysToCamel(filteredResponse);
    }

    return keysToCamel(sortedResponse);
  };

  analysisDetails.forEach(analysis => {
    const { id, status, observations } = analysis;
    const maximumInstallmentOption = analysis.complete_values?.installments_data.find(
      i => {
        return (
          i.installments_amount === analysis.complete_values.maximum_installments_amount
        );
      }
    );
    let maximumFormattedInstallmentValue: string;

    if (maximumInstallmentOption) {
      maximumFormattedInstallmentValue = maskMoney(
        `${maximumInstallmentOption.total_premium_amount}`,
        true
      );
    } else {
      maximumFormattedInstallmentValue = analysis.value
        ? maskMoney(`${analysis.value}`, true)
        : '0,00';
    }

    analysisFormData.push({
      id,
      status,
      observations,
      code: analysis.code,
      userId: analysis.user_id,
      user: analysis.user,
      offers:
        analysis.insurer_response || analysis.insurer.code === InsurersCodeEnum.Garantti
          ? getOffers(analysis.insurer.code, analysis.insurer_response)
          : [],
      insurer: analysis.insurer,
      value: maximumFormattedInstallmentValue,
      completeValues: analysis.complete_values,
      createdAt: analysis.created_at,
      updatedAt: analysis?.updated_at,
      expired_at: analysis?.expired_at,
      preapprovedValue: analysis?.preapproved_value,
      biometryUrl: analysis?.biometry_url,
      insurerResponse: analysis?.insurer_response,
      isManualAnalysis: analysis?.is_manual_analysis
    });

    // analysisFormData.sort(({ createdAt: a }, { createdAt: b }) => a < b ? -1 : a > b ? 1 : 0);
  });

  const getStatusColor = (status: string): string => {
    switch (status) {
      case BondInsuranceAnalysisStatusEnum.pending:
        return '#FBBD08';
      case BondInsuranceAnalysisStatusEnum.proposal:
        return '#710193';
      case BondInsuranceAnalysisStatusEnum.preapproved:
        return 'teal';
      case BondInsuranceAnalysisStatusEnum.analysis:
        return '#2185D0';
      case BondInsuranceAnalysisStatusEnum.approved:
        return '#21BA45';
      case BondInsuranceAnalysisStatusEnum.rejected:
        return '#DB2828';
      case BondInsuranceAnalysisStatusEnum.biometry:
        return '#FE9A76';
      case BondInsuranceAnalysisStatusEnum.waiting:
        return 'grey';
      case BondInsuranceAnalysisStatusEnum.error:
        return 'black';
      default:
        return 'grey';
    }
  };

  const getStatusText = (status: string, analysis?: any): string => {
    switch (status) {
      case BondInsuranceAnalysisStatusEnum.waiting:
        return 'EM ESPERA';
      case BondInsuranceAnalysisStatusEnum.pending:
        return 'PENDENCIADO';
      case BondInsuranceAnalysisStatusEnum.proposal:
        return 'EM PROPOSTA';
      case BondInsuranceAnalysisStatusEnum.analysis:
        return 'EM ANÁLISE';
      case BondInsuranceAnalysisStatusEnum.approved:
        return 'APROVADO';
      case BondInsuranceAnalysisStatusEnum.preapproved:
        return getPreapprovedStatusLabel(analysis ?? { status });
      case BondInsuranceAnalysisStatusEnum.rejected:
        return 'REPROVADO';
      case BondInsuranceAnalysisStatusEnum.biometry:
        return 'BIOMETRIA';
      default:
        return 'INDEFINIDO';
    }
  };

  const isAnalysisExpired = (analysis: any): boolean => {
    const expiredAt = analysis.expired_at || analysis.expiredAt;
    return expiredAt ? new Date() > new Date(expiredAt) : false;
  };

  type DocumentsComponentProps = {
    registerId: string;
  };

  useEffect(() => {
    if (props.externalBondInsuranceAnalysisId) {
      open();
    }
  }, [open, props.externalBondInsuranceAnalysisId]);

  useEffect(() => {
    if (typeof props.open === 'boolean') {
      setIsOpen(props.open);
      if (!props.open) {
        setIsLoading(false);
      }
    }
  }, [props.open]);

  useEffect(() => {
    if (isOpen) {
      setDisplayTab('resultados');
      setIsLoading(false);
    }
  }, [isOpen]);

  function HireModal({ analysis }: any): JSX.Element {
    const analysisComp = bondInsurance?.bond_insurance_analysis.find(
      item => item.insurer.code === analysis.insurer.code
    );

    bondInsurance.analysis_assurance =
      (analysisComp?.analysis_assurance as AnalysisAssuranceEnum) ??
      bondInsurance.analysis_assurance;

    if (analysis.status === BondInsuranceAnalysisStatusEnum.biometry) {
      return analysis.insurer.code === InsurersCodeEnum.Pottencial ? (
        <RegisterBiometricsModal
          insurer={analysis.insurer.code}
          url={analysis.biometryUrl}
        />
      ) : (
        <></>
      );
    }

    if (bondInsurance.tenant_type === PersonTypesEnum.natural) {
      if (
        analysis.insurer.code === InsurersCodeEnum.Pottencial &&
        analysis.offers.length > 0 &&
        !analysis.isManualAnalysis
      ) {
        // Verificar se a análise foi criada após as 17:30 de 08/09/2025
        const deployDate = new Date(2025, 8, 8, 17, 30, 0);
        const analysisCreatedAt = new Date(analysis.createdAt);

        if (analysisCreatedAt > deployDate) {
          return (
            <PottencialHireProposalModal
              callback={callback}
              bondInsurance={bondInsurance}
              analysis={analysis}
              closeModal={close}
              open={analysis.id === props.externalBondInsuranceAnalysisId}
              cleanIdReferences={props.cleanIdReferences}
            />
          );
        }
      }

      if (
        InsurersCodeEnum.PortoEssencial === analysis.insurer.code &&
        analysis.offers.length > 0 &&
        !analysis.isManualAnalysis
      ) {
        return (
          <HirePortoModal
            bondInsurance={bondInsurance}
            analysis={analysis}
            estate={estate!}
            callback={callback}
            open={analysis.id === props.externalBondInsuranceAnalysisId}
            cleanIdReferences={props.cleanIdReferences}
          />
        );
      }
    }

    if (
      InsurersCodeEnum.Garantti === analysis.insurer.code &&
      !analysis.isManualAnalysis
    ) {
      return (
        <GaranttiHireProposalModal
          callback={callback}
          setOpen={setOpenHireProposalModal}
          bondInsurance={bondInsurance}
          rentOnly={false}
          username={user.name}
          insurer={analysis.insurer}
          property={property}
          user_id={user.id}
          estate_id={estate!.id}
          naturalTentant={naturalTentant}
          analysisID={analysis.id}
          maxInstallments={analysis.completeValues.maximum_installments_amount}
          nominal_total_premium_amount={
            analysis.completeValues?.nominal_total_premium_amount
          }
          closeModal={close}
          open={analysis.id === props.externalBondInsuranceAnalysisId}
          cleanIdReferences={props.cleanIdReferences}
          approvedAt={analysis.createdAt}
          offers={analysis.offers}
        />
      );
    }

    if (
      InsurersCodeEnum.Porto === analysis.insurer.code &&
      analysis.code &&
      !analysis.userId
    ) {
      return (
        <HirePortoTradicionalModal
          bondInsurance={bondInsurance}
          analysis={analysis}
          estate={estate!}
          callback={callback}
          open={analysis.id === props.externalBondInsuranceAnalysisId}
          cleanIdReferences={props.cleanIdReferences}
        />
      );
    }

    // Segimob só contrata com ofertas reais da API. Análise Too aprovada
    // na mão (status/valor) costuma ter código, mas sem insurer_response —
    // nesse caso cai no fluxo geral, sem exigir plano.
    const hasTooSegimobOffers =
      Array.isArray(analysis.offers) &&
      analysis.offers.some(
        (offer: any) =>
          (offer?.id || offer?.codigoOrcamento) &&
          Number(offer?.valorParcela) > 0 &&
          offer?.nomeSeguro
      );

    if (
      analysis.insurer.code === InsurersCodeEnum.Too &&
      !analysis.isManualAnalysis &&
      hasTooSegimobOffers
    ) {
      return (
        <SegimobHireProposalModal
          callback={callback}
          setOpen={setOpenHireProposalModal}
          bondInsurance={bondInsurance}
          rentOnly={false}
          username={user.name}
          insurer={analysis.insurer}
          property={property}
          user_id={user.id}
          estate_id={estate!.id}
          naturalTentant={naturalTentant}
          analysisID={analysis.id}
          maxInstallments={analysis.completeValues.maximum_installments_amount}
          nominal_total_premium_amount={
            analysis.completeValues?.nominal_total_premium_amount
          }
          closeModal={close}
          open={analysis.id === props.externalBondInsuranceAnalysisId}
          cleanIdReferences={props.cleanIdReferences}
          approvedAt={analysis.createdAt}
          offers={analysis.offers}
        />
      );
    }

    return (
      <GeneralHireProposalModal
        callback={callback}
        setOpen={setOpenHireProposalModal}
        bondInsurance={bondInsurance}
        rentOnly={false}
        username={user.name}
        insurer={analysis.insurer}
        property={property}
        user_id={user.id}
        estate_id={estate!.id}
        naturalTentant={naturalTentant}
        analysisID={analysis.id}
        maxInstallments={analysis.completeValues.maximum_installments_amount}
        nominal_total_premium_amount={
          analysis.completeValues?.nominal_total_premium_amount
        }
        closeModal={close}
        open={analysis.id === props.externalBondInsuranceAnalysisId}
        cleanIdReferences={props.cleanIdReferences}
        approvedAt={analysis.createdAt}
        offers={analysis.offers}
      />
    );
  }

  const DisplayTab = ({
    title,
    tab,
    first,
    end
  }: {
    title: string;
    tab: 'detalhes' | 'resultados' | 'logs';
    first: boolean;
    end: boolean;
  }) => {
    let styleBase: CSSProperties = {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '8px 18px',
      minWidth: '120px',
      backgroundColor: displayTab === tab ? '#854EE0' : '#FFFFFF',
      color: displayTab === tab ? '#FFFFFF' : '#6B6F77',
      cursor: displayTab === tab ? 'initial' : 'pointer'
    };

    if (first) {
      styleBase = {
        ...styleBase,
        border: '1px solid #DDDDDD',
        borderTopLeftRadius: '4px',
        borderBottomLeftRadius: '4px'
      };
    }

    if (end) {
      styleBase = {
        ...styleBase,
        border: '1px solid #DDDDDD',
        borderTopRightRadius: '4px',
        borderBottomRightRadius: '4px'
      };
    }

    if (!first && !end) {
      styleBase = {
        ...styleBase,
        borderTop: '1px solid #DDDDDD',
        borderBottom: '1px solid #DDDDDD'
      };
    }

    return (
      <div onClick={() => setDisplayTab(tab)} style={styleBase}>
        {title}
      </div>
    );
  };

  const DetailsBlock = () => {
    const DetailsCard = ({ title, value }: { title: string; value: string }) => {
      return (
        <div>
          <div style={{ color: '#6B6F77', fontSize: '12px' }}>{title}</div>
          <div style={{ color: '#2B313C', fontSize: '14px' }}>{value}</div>
        </div>
      );
    };

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1.2rem',
          marginTop: '2rem',
          marginBottom: '2rem',
          borderLeft: '4px solid #59249B',
          paddingLeft: '16px'
        }}
      >
        <div style={{ display: 'flex', gap: 32 }}>
          <DetailsCard
            title={'Tipo do contratante'}
            value={
              bondInsurance.tenant_type === 'NATURAL'
                ? 'Pessoa Física'
                : 'Pessoa Jurídica'
            }
          />
          <DetailsCard title={'Inquilino'} value={tenant_name} />
          <DetailsCard title={'Documento'} value={maskCpfOrCnpj(tenant_document)} />
          <DetailsCard title={'Endereço do imóvel'} value={address} />
        </div>
        <div style={{ display: 'flex', gap: 32 }}>
          <DetailsCard
            title={'Tipo de locação'}
            value={bondInsurance.purpose === 'RESIDENTIAL' ? 'Residencial' : 'Comercial'}
          />
          <DetailsCard
            title={'Valor do aluguel'}
            value={Number(bondInsurance.property.rent_value).toLocaleString('pt-BR', {
              currency: 'BRL',
              style: 'currency'
            })}
          />
          <DetailsCard
            title={'Valor final'}
            value={Number(bondInsurance.property.total_amount).toLocaleString('pt-BR', {
              currency: 'BRL',
              style: 'currency'
            })}
          />
          <DetailsCard title={'Imobiliária'} value={bondInsurance.estate?.name || '-'} />
        </div>
      </div>
    );
  };

  const ResultsContent = () => {
    return (
      <>
        <DetailsBlock />

        <Formik
          initialValues={{ analysis: analysisFormData }}
          validationSchema={{}}
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          onSubmit={() => {}}
        >
          {innerProps => {
            const { setFieldValue, setFieldTouched, setValues, values } = innerProps;
            const { analysis } = values;

            const sortedAnalysis = [...analysis].sort((a, b) =>
              a.insurer.name.localeCompare(b.insurer.name)
            );

            const updateAnalysisItem = (index: number, changes: Record<string, any>) => {
              setValues({
                ...values,
                analysis: analysis.map((item, itemIndex) =>
                  itemIndex === index ? { ...item, ...changes } : item
                )
              });
            };

            const getStatusLabel = () => {
              return (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  STATUS DA ANÁLISE
                  <Popup
                    trigger={
                      <Icon
                        name="info circle"
                        color="blue"
                        size="large"
                        style={{ marginLeft: '16px' }}
                      />
                    }
                    content={
                      <div style={{ display: 'flex', width: '360px' }}>
                        <ul style={{ marginLeft: 0, paddingLeft: '24px' }}>
                          <li style={{ marginBottom: '16px' }}>
                            <h4>Pré-aprovado:</h4>
                            <p>
                              <strong>Atenção</strong>: este status de Pré-aprovado
                              significa que a análise está em estágio de pré-aprovação
                              pois o valor aprovado foi menor que o valor total
                              solicitado.
                            </p>
                          </li>
                          <li style={{ marginBottom: '16px' }}>
                            <h4>Aprovado com Limite Inferior (Pottencial):</h4>
                            <p>
                              <strong>Atenção</strong>: a Pottencial recusou a cotação,
                              mas informou um limite aprovado para o inquilino dentro da
                              tolerância. Para uma possível aprovação, realize uma
                              reanálise ajustando aluguel + encargos para até o limite
                              aprovado.
                            </p>
                          </li>
                          <li style={{ marginBottom: '16px' }}>
                            <h4>Biometria</h4>
                            <p>
                              <strong>Atenção</strong>: este status de Biometria indica
                              que a análise está pendente do cliente realizar o
                              reconhecimento facial para conseguir prosseguir com a
                              aprovação e contratação.
                            </p>
                          </li>
                          {/* <li style={{ marginBottom: '16px' }}>
                          <h4>Taxa setup</h4>
                          <p>
                            <strong>Atenção</strong>: este status indica que o cliente precisa realizar o pagamento
                            da taxa de setup solicitada.
                          </p>
                        </li> */}
                        </ul>
                      </div>
                    }
                  />
                </div>
              );
            };

            return (
              <>
                {openEditPlansModal && selectedAnalysisIndex !== null && (
                  <EditPlansModal
                    analysisDetails={analysis[selectedAnalysisIndex]}
                    index={selectedAnalysisIndex}
                    setFieldValueDetails={setFieldValue}
                    analysisList={analysisDetails[selectedAnalysisIndex]}
                    open={openEditPlansModal}
                    onClose={closeEditPlansModal}
                  />
                )}

                <ConfirmationModalContent>
                  <Dimmer active={loadingPottencialStatus}>
                    <Loader indeterminate> Aguarde... </Loader>
                  </Dimmer>
                  {showCapitalizationModal &&
                    user.role !== UserRolesEnum.estateQuotation && (
                    <div
                      style={{
                        display: 'flex',
                        width: '100%',
                        marginTop: '-15px'
                      }}
                    >
                      <span
                        style={{
                          textAlign: 'center',
                          marginLeft: 'auto',
                          fontWeight: 'bold',
                          fontSize: '18px',
                          marginRight: '10px',
                          paddingTop: '4px',
                          color: '#2185d0'
                        }}
                      >
                        Seu cliente não foi aprovado no seguro fiança? Não perca negócio,
                        contrate agora um título de capitalização!
                      </span>
                      <EditCapitalizationModal
                        externalOpenModal={externalOpenEditCapitalizationModal}
                        bondInsuance={bondInsurance}
                        trigger={
                          <Button color="green">
                            <span
                              style={{
                                textAlign: 'center',
                                fontSize: '16px'
                              }}
                            >
                              Contratar Título
                            </span>
                          </Button>
                        }
                      />
                    </div>
                  )}

                  <Table>
                    <Table.Header>
                      <Table.Row>
                        {!user.role!.includes('ESTATE') && (
                          <>
                            <Table.HeaderCell width={1}>#</Table.HeaderCell>
                            <Table.HeaderCell width={2}>SEGURADORA</Table.HeaderCell>
                            <Table.HeaderCell width={2}>
                              {getStatusLabel()}
                            </Table.HeaderCell>
                            <Table.HeaderCell width={3}>OBSERVAÇÕES</Table.HeaderCell>
                            <Table.HeaderCell width={2}>VALOR INFORMADO</Table.HeaderCell>
                            <Table.HeaderCell width={2}>
                              VALOR DA PARCELA
                            </Table.HeaderCell>
                            <Table.HeaderCell width={2}>AÇÕES</Table.HeaderCell>
                          </>
                        )}
                        {user.role!.includes('ESTATE') && (
                          <>
                            <Table.HeaderCell width={4}>SEGURADORA</Table.HeaderCell>
                            <Table.HeaderCell width={3}>
                              {getStatusLabel()}
                            </Table.HeaderCell>
                            <Table.HeaderCell width={3}>VALOR INFORMADO</Table.HeaderCell>
                            <Table.HeaderCell width={3}>
                              VALOR DA PARCELA
                            </Table.HeaderCell>
                            <Table.HeaderCell width={3}>AÇÕES</Table.HeaderCell>
                          </>
                        )}
                      </Table.Row>
                    </Table.Header>

                    <Table.Body>
                      {sortedAnalysis.map(a => {
                        const index = analysis.findIndex(item => item.id === a.id);

                        if (index < 0) {
                          return null;
                        }

                        const isBefore25Day =
                          1637793334220 < new Date(a.createdAt).getTime();
                        const allRefused = analysis.every(
                          a => a.status === BondInsuranceAnalysisStatusEnum.rejected
                        );
                        const newInstallments = validityMonths;
                        const sendLetterEnabled =
                          (analysis[index].status ===
                            BondInsuranceAnalysisStatusEnum.approved &&
                            values.analysis[index] &&
                            (unmaskMoney(values.analysis[index].value) > 0 ||
                              a.insurer.code === InsurersCodeEnum.PortoEssencial)) ||
                          analysis[index].status ===
                            BondInsuranceAnalysisStatusEnum.rejected ||
                          analysis[index].status ===
                            BondInsuranceAnalysisStatusEnum.pending ||
                          analysis[index].status ===
                            BondInsuranceAnalysisStatusEnum.preapproved ||
                          analysis[index].status ===
                            BondInsuranceAnalysisStatusEnum.biometry;

                      const isExpired = isAnalysisExpired(a);

                      let buttonText = 'Enviar Carta';
                      let buttonColor = 'blue';
                      if (a.status === BondInsuranceAnalysisStatusEnum.approved) {
                        buttonText = 'Enviar Carta de Aprovação';
                        buttonColor = 'green';
                      } else if (a.status === BondInsuranceAnalysisStatusEnum.rejected) {
                        buttonText = 'Enviar Carta de Recusa';
                        buttonColor = 'red';
                      } else if (a.status === BondInsuranceAnalysisStatusEnum.pending) {
                        buttonText = 'Enviar Carta de Pendência';
                        buttonColor = 'yellow';
                      } else if (a.status === BondInsuranceAnalysisStatusEnum.biometry) {
                        buttonText = 'Enviar Status Biometria';
                        buttonColor = 'orange';
                      } else if (
                        a.status === BondInsuranceAnalysisStatusEnum.preapproved
                      ) {
                        buttonText = isPottencialLowerLimitPreapproved(a)
                          ? 'Enviar Aprovado com Limite Inferior'
                          : 'Enviar Status Pré-aprovado';
                        buttonColor = 'teal';
                      }

                        return (
                          <>
                            <Table.Row key={index}>
                              {!user.role!.includes('ESTATE') && (
                                <Table.Cell>
                                  <Icon
                                    name="circle"
                                    style={{ color: getStatusColor(a.status) }}
                                  ></Icon>
                                  {a.user && (
                                    <Popup
                                      trigger={<Icon name="user" color="blue" />}
                                      content={
                                        a.user.name +
                                        ' - ' +
                                        moment(a.updatedAt).format('DD/MM/YYYY HH:mm:ss')
                                      }
                                    />
                                  )}
                                </Table.Cell>
                              )}
                              <Table.Cell>
                                {
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'space-between'
                                    }}
                                  >
                                    <div>
                                      {a.insurer.name} <br />
                                      <Popup
                                        content="Data e hora de realização da analise"
                                        trigger={
                                          <span
                                            style={{ color: '#afafaf', fontSize: '12px' }}
                                          >
                                            &gt;{' '}
                                            {format(
                                              new Date(a.createdAt),
                                              'dd/MM/yyyy HH:mm',
                                              { locale: ptBR }
                                            )}
                                          </span>
                                        }
                                      />
                                    </div>

                                    <div>
                                      {(user.role === UserRolesEnum.brokerAdmin ||
                                        user.role === UserRolesEnum.franchiseAdmin ||
                                        user.role ===
                                          UserRolesEnum.multiFranchiseAdmin) &&
                                        (a.insurer.code === InsurersCodeEnum.Porto ||
                                          a.insurer.code ===
                                            InsurersCodeEnum.PortoEssencial ||
                                          a.insurer.code ===
                                            InsurersCodeEnum.Pottencial ||
                                          a.insurer.code === InsurersCodeEnum.Too ||
                                          a.insurer.code ===
                                            InsurersCodeEnum.Garantti) && (
                                          <Popup
                                            content="Editar Planos"
                                            trigger={
                                              <button
                                                style={{
                                                  border: 'none',
                                                  backgroundColor: 'transparent'
                                                }}
                                                onClick={() => {
                                                  setSelectedAnalysisIndex(index);
                                                  setOpenEditPlansModal(true);
                                                }}
                                              >
                                                <IconButton name="edit outline" />
                                              </button>
                                            }
                                          />
                                        )}
                                    </div>
                                  </div>
                                }
                              </Table.Cell>
                              <Table.Cell>
                                {isExpired ? (
                                  <IconText
                                    iconName={'circle'}
                                    iconColor={'#8c8c8c'}
                                    text={`EXPIRADA (${getStatusText(a.status, a)})`}
                                  />
                                ) : (
                                  <>
                                {user.role!.includes('ESTATE') && (
                                  <>
                                    {a.status ===
                                    BondInsuranceAnalysisStatusEnum.biometry ? (
                                      <div
                                        style={{
                                          display: 'flex',
                                          alignItems: 'flex-start'
                                        }}
                                      >
                                        <IconText
                                          iconName={'circle'}
                                          iconColor={getStatusColor(a.status)}
                                          text={getStatusText(a.status, a)}
                                        />
                                        <Popup
                                          trigger={
                                            <Icon
                                              name="warning sign"
                                              color="yellow"
                                              style={{ marginLeft: '16px' }}
                                            />
                                          }
                                          content={
                                            <div>
                                              <p>
                                                <strong>Atenção</strong>: este status de
                                                Biometria é um status intermediário criado
                                                para controlar o estágio do fiança que a
                                                seguradora solicita o reconhecimento da
                                                biometria facial para confirmar a
                                                aprovação do seguro. Sendo que neste
                                                estágio, poderá ocorrer Recusa e/ou
                                                alteração de valor original da análise
                                                (ainda que muito pequena) quando mudar de
                                                biometria para aprovado, após a
                                                confirmação da biometria facial pelo
                                                cliente.
                                              </p>
                                            </div>
                                          }
                                        />
                                      </div>
                                    ) : isPottencialLowerLimitPreapproved(a) ? (
                                      <div
                                        style={{
                                          display: 'flex',
                                          alignItems: 'flex-start'
                                        }}
                                      >
                                        <IconText
                                          iconName={'circle'}
                                          iconColor={getStatusColor(a.status)}
                                          text={getStatusText(a.status, a)}
                                        />
                                        <Popup
                                          trigger={
                                            <Icon
                                              name="warning sign"
                                              color="yellow"
                                              style={{ marginLeft: '16px' }}
                                            />
                                          }
                                          content={
                                            <div style={{ maxWidth: 360 }}>
                                              <p>
                                                <strong>Atenção</strong>: pré-aprovado
                                                com limite inferior. Para uma possível
                                                aprovação, faça uma reanálise ajustando
                                                aluguel + encargos para até{' '}
                                                <strong>
                                                  R${' '}
                                                  {Number(a.preapprovedValue)
                                                    .toFixed(2)
                                                    .replace('.', ',')}
                                                </strong>
                                                , limite aprovado pela Pottencial.
                                              </p>
                                            </div>
                                          }
                                        />
                                      </div>
                                    ) : (
                                      <IconText
                                        iconName={'circle'}
                                        iconColor={getStatusColor(a.status)}
                                        text={getStatusText(a.status, a)}
                                      />
                                    )}
                                  </>
                                )}
                                {!user.role!.includes('ESTATE') && (
                                  <>
                                    {a.status ===
                                    BondInsuranceAnalysisStatusEnum.biometry ? (
                                      <Popup
                                        style
                                        trigger={
                                          <Field
                                            name={`analysis[${index}].status`}
                                            completeValue={true}
                                            placeholder={'Selecionar...'}
                                            options={statusOptions}
                                            component={StatusDropdown}
                                            disabled={isEstateQuotationUser || !canEdit}
                                            onChange={(_: SyntheticEvent, data: any) => {
                                              setHasChange(true);
                                              const changes: Record<string, any> = {
                                                status: data.value,
                                                userId: user.id
                                              };

                                              if (
                                                data.value ===
                                                  BondInsuranceAnalysisStatusEnum.approved &&
                                                a.status ===
                                                  BondInsuranceAnalysisStatusEnum.preapproved &&
                                                a.insurer.code.includes('PORTO')
                                              ) {
                                                setFieldValue(
                                                  `analysis[${index}].value`,
                                                  maskMoney('0', true)
                                                );
                                                changes.value = maskMoney('0', true);
                                                setIsRequired(true);
                                              }

                                              if (
                                                a.insurer.code ===
                                                  InsurersCodeEnum.Creditas &&
                                                (data.value ===
                                                  BondInsuranceAnalysisStatusEnum.approved ||
                                                  data.value ===
                                                    BondInsuranceAnalysisStatusEnum.biometry) &&
                                                (!a.value || unmaskMoney(a.value) === 0)
                                              ) {
                                                const creditasValue = maskMoney(
                                                  String(
                                                    Number(
                                                      bondInsurance.property?.rent_value ||
                                                        0
                                                    ) * 0.125
                                                  ),
                                                  true
                                                );
                                                setFieldValue(
                                                  `analysis[${index}].value`,
                                                  creditasValue
                                                );
                                                changes.value = creditasValue;
                                              }

                                              setAnalysisChanged(current =>
                                                current.concat(index)
                                              );
                                              updateAnalysisItem(index, changes);
                                            }}
                                            onClose={() =>
                                              setFieldTouched(
                                                `analysis[${index}].status`,
                                                true
                                              )
                                            }
                                            fluid
                                          />
                                        }
                                        content={
                                          <div>
                                            <p>
                                              <strong>Atenção</strong>: este status de
                                              Biometria é um status intermediário criado
                                              para controlar o estágio do fiança que a
                                              seguradora solicita o reconhecimento da
                                              biometria facial para confirmar a aprovação
                                              do seguro. Sendo que neste estágio, poderá
                                              ocorrer Recusa e/ou alteração de valor
                                              original da análise (ainda que muito
                                              pequena) quando mudar de pbiometria para
                                              aprovado, após a confirmação da biometria
                                              facial pelo cliente.
                                            </p>
                                          </div>
                                        }
                                      />
                                    ) : (
                                      <Field
                                        name={`analysis[${index}].status`}
                                        completeValue={true}
                                        placeholder={'Selecionar...'}
                                        options={statusOptions}
                                        component={StatusDropdown}
                                        disabled={isEstateQuotationUser || !canEdit}
                                        onChange={(_: SyntheticEvent, data: any) => {
                                          setHasChange(true);
                                          const changes: Record<string, any> = {
                                            status: data.value,
                                            userId: user.id
                                          };

                                          if (
                                            a.insurer.code ===
                                              InsurersCodeEnum.Creditas &&
                                            (data.value ===
                                              BondInsuranceAnalysisStatusEnum.approved ||
                                              data.value ===
                                                BondInsuranceAnalysisStatusEnum.biometry) &&
                                            (!a.value || unmaskMoney(a.value) === 0)
                                          ) {
                                            const creditasValue = maskMoney(
                                              String(
                                                Number(
                                                  bondInsurance.property?.rent_value || 0
                                                ) * 0.125 // 12,5%
                                              ),
                                              true
                                            );
                                            setFieldValue(
                                              `analysis[${index}].value`,
                                              creditasValue
                                            );
                                            changes.value = creditasValue;
                                          }

                                          setAnalysisChanged(current =>
                                            current.concat(index)
                                          );
                                          updateAnalysisItem(index, changes);
                                        }}
                                        onClose={() =>
                                          setFieldTouched(
                                            `analysis[${index}].status`,
                                            true
                                          )
                                        }
                                        fluid
                                      />
                                    )}
                                  </>
                                )}
                                  </>
                                )}
                              </Table.Cell>
                              {!user.role!.includes('ESTATE') && (
                                <Table.Cell>
                                  <Field
                                    name={`analysis[${index}].observations`}
                                    rows={1}
                                    disabled={!canEdit}
                                    value={a.observations}
                                    onChange={(_: SyntheticEvent, data: any) => {
                                      setHasChange(true);
                                      setAnalysisChanged(analysisChanged.concat(index));
                                      setFieldValue(
                                        `analysis[${index}].observations`,
                                        data.value
                                      );
                                    }}
                                    onBlur={() =>
                                      setFieldTouched(
                                        `analysis[${index}].observations`,
                                        true
                                      )
                                    }
                                    component={TextArea}
                                    fluid
                                  />
                                </Table.Cell>
                              )}

                              {a.status === 'PREAPPROVED' ? (
                                <Table.Cell>
                                  <div
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'column',
                                      alignItems: 'center'
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        paddingBottom: '8px'
                                      }}
                                    >
                                      <Icon
                                        name="warning sign"
                                        color="yellow"
                                        size="small"
                                      />
                                      <p
                                        style={{
                                          fontSize: 12,
                                          fontWeight: 600,
                                          textDecoration: 'line-through',
                                          color: '#A3A3A3'
                                        }}
                                      >
                                        R${' '}
                                        {Number(props.property.total_amount)
                                          .toFixed(2)
                                          .replace('.', ',')}
                                      </p>
                                    </div>
                                    <p
                                      style={{
                                        fontSize: 12,
                                        fontWeight: 700,
                                        textAlign: 'center',
                                        color: '#393939',
                                        margin: 0,
                                        paddingBottom: '4px'
                                      }}
                                    >
                                      R${' '}
                                      {Number(a.preapprovedValue)
                                        .toFixed(2)
                                        .replace('.', ',') ?? 0}
                                    </p>
                                    <p
                                      style={{
                                        fontSize: 12,
                                        fontWeight: 400,
                                        textAlign: 'center',
                                        color: '#808080',
                                        margin: 0
                                      }}
                                    >
                                      {isPottencialLowerLimitPreapproved(a)
                                        ? 'Pré-aprovado com limite inferior. Para uma possível aprovação, faça uma reanálise ajustando aluguel + encargos para até o limite aprovado pela Pottencial.'
                                        : 'Aprovado com valor reduzido.'}
                                    </p>
                                  </div>
                                </Table.Cell>
                              ) : (
                                <Table.Cell>
                                  <p
                                    style={{
                                      fontSize: 12,
                                      fontWeight: 700,
                                      textAlign: 'center',
                                      color: '#393939',
                                      margin: 0,
                                      paddingBottom: '4px'
                                    }}
                                  >
                                    R${' '}
                                    {Number(props.property.total_amount)
                                      .toFixed(2)
                                      .replace('.', ',')}
                                  </p>
                                </Table.Cell>
                              )}

                              {!user.role!.includes('ESTATE') && (
                                <Table.Cell>
                                  <Grid style={{ padding: '10px 0 10px 0' }}>
                                    {a.offers.length > 0 &&
                                    a.offers.some((o: any) => o?.valorParcela > 0) &&
                                    a.status !==
                                      BondInsuranceAnalysisStatusEnum.rejected &&
                                    a.status !==
                                      BondInsuranceAnalysisStatusEnum.preapproved &&
                                    !(
                                      a.insurer.code === InsurersCodeEnum.Pottencial &&
                                      a.isManualAnalysis
                                    )
                                      ? a.offers.map((c: any, i: number) => {
                                          let planName = c.nomeSeguro;

                                          if (
                                            InsurersCodeEnum.Garantti === a.insurer.code
                                          ) {
                                            planName = `${c.nomeSeguro} ${
                                              c.residentialFee || c.commercialFee
                                            }%`;
                                          }

                                          if (
                                            !c ||
                                            !c.quantidadeParcela ||
                                            !c.valorParcela ||
                                            !c.nomeSeguro
                                          ) {
                                            return;
                                          }

                                          return (
                                            <Popup
                                              trigger={
                                                <Grid.Row
                                                  style={{
                                                    alignItems: 'center',
                                                    margin: '2px',
                                                    padding: '2px'
                                                  }}
                                                >
                                                  <Grid.Column width={1}>
                                                    {`${c.quantidadeParcela}x`}
                                                  </Grid.Column>

                                                  <Grid.Column width={13}>
                                                    <Field
                                                      name={`analysis[${index}].offers[${i}].value`}
                                                      disabled={true}
                                                      value={c.valorParcela.toLocaleString(
                                                        'pt-BR',
                                                        {
                                                          style: 'currency',
                                                          currency: 'BRL'
                                                        }
                                                      )}
                                                      component={Input}
                                                      fluid
                                                    />
                                                  </Grid.Column>
                                                </Grid.Row>
                                              }
                                              content={planName}
                                              position={'left center'}
                                              key={c.id}
                                            />
                                          );
                                        })
                                      : a.status !==
                                          BondInsuranceAnalysisStatusEnum.rejected &&
                                        a.status !==
                                          BondInsuranceAnalysisStatusEnum.preapproved && (
                                          <Grid.Row
                                            style={{
                                              alignItems: 'center',
                                              marginBottom: '10px'
                                            }}
                                          >
                                            <Grid.Column width={1}>
                                              {`${newInstallments}x`}
                                            </Grid.Column>

                                            <Grid.Column width={13}>
                                              <Field
                                                name={`analysis[${index}].value`}
                                                required={isRequired}
                                                disabled={
                                                  // analysis[index].status !==
                                                  // BondInsuranceAnalysisStatusEnum.approved &&
                                                  // analysis[index].status !==
                                                  // BondInsuranceAnalysisStatusEnum.preapproved
                                                  !canEdit
                                                }
                                                value={analysis[index].value}
                                                onChange={(
                                                  _: SyntheticEvent,
                                                  data: any
                                                ) => {
                                                  setHasChange(true);
                                                  setAnalysisChanged(
                                                    analysisChanged.concat(index)
                                                  );
                                                  setFieldValue(
                                                    `analysis[${index}].value`,
                                                    formatAmount(data.value)
                                                  );
                                                  setFieldValue(
                                                    `analysis[${index}].userId`,
                                                    user.id
                                                  );
                                                }}
                                                onBlur={() => {
                                                  setFieldTouched(
                                                    `analysis[${index}].value`,
                                                    true
                                                  );
                                                }}
                                                component={Input}
                                                fluid
                                              />
                                            </Grid.Column>
                                          </Grid.Row>
                                        )}
                                  </Grid>
                                </Table.Cell>
                              )}
                              {user.role!.includes('ESTATE') && (
                                <Table.Cell>
                                  {a.offers.length > 0 &&
                                  a.status !== BondInsuranceAnalysisStatusEnum.rejected &&
                                  a.status !==
                                    BondInsuranceAnalysisStatusEnum.preapproved &&
                                  !(
                                    a.insurer.code === InsurersCodeEnum.Pottencial &&
                                    a.isManualAnalysis
                                  ) ? (
                                    a.offers.map((c: any) => {
                                      if (
                                        !c ||
                                        !c.quantidadeParcela ||
                                        !c.valorParcela ||
                                        !c.nomeSeguro
                                      ) {
                                        return;
                                      }
                                      return (
                                        <Popup
                                          trigger={
                                            <p>
                                              {`${c.quantidadeParcela} x R$ ${maskMoney(
                                                `${c.valorParcela}`,
                                                true,
                                                2
                                              )}`}
                                            </p>
                                          }
                                          content={`${c.nomeSeguro} ${
                                            InsurersCodeEnum.Garantti === a.insurer.code
                                              ? `${c.residentialFee || c.commercialFee}%`
                                              : ''
                                          }`}
                                          position={'left center'}
                                          key={c.id}
                                        />
                                      );
                                    })
                                  ) : a.value &&
                                    unmaskMoney(a.value) > 0 &&
                                    a.status !==
                                      BondInsuranceAnalysisStatusEnum.rejected &&
                                    a.status !==
                                      BondInsuranceAnalysisStatusEnum.preapproved ? (
                                    <div
                                      style={{
                                        display: 'flex',
                                        alignItems: 'flex-start'
                                      }}
                                    >
                                      <p style={{ margin: 0 }}>
                                        {`${newInstallments} x R$ ${maskMoney(
                                          `${a.value}` || '0'
                                        )}`}
                                      </p>
                                    </div>
                                  ) : (
                                    <p></p>
                                  )}
                                </Table.Cell>
                              )}

                            <Table.Cell width={3}>
                              <RowButtons>
                                {isExpired ? (
                                  <div style={{ width: '100%' }}>
                                    <Button disabled color="grey" fluid>
                                      Aprovação Expirada
                                    </Button>
                                  </div>
                                ) : (
                                  <>
                                    {a.status ===
                                      BondInsuranceAnalysisStatusEnum.biometry && (
                                        <HireModal analysis={a} />
                                      )}
                                    {a.status === BondInsuranceAnalysisStatusEnum.approved &&
                                      isBefore25Day &&
                                      (isEstateQuotationUser ? (
                                        <Button disabled positive fluid>
                                          Contratar
                                        </Button>
                                      ) : (
                                        <HireModal analysis={a} />
                                      ))}
                                {a.status === BondInsuranceAnalysisStatusEnum.rejected &&
                                  a.insurer.code === InsurersCodeEnum.Garantti &&
                                  allRefused && (
                                    <GeneralReanalysisModal
                                      bondInsurance={bondInsurance}
                                      nominalTotalPremiumAmount={0}
                                      callback={callback}
                                      close={close}
                                    />
                                  )}
                                {a.status !== BondInsuranceAnalysisStatusEnum.approved &&
                                  !user.role!.includes('ESTATE') && (
                                    <AuthorizationContainer
                                      action={ActionEnum.send}
                                      feature={FeatureEnum.letters}
                                    >
                                      <Popup
                                        content={
                                          !openHireProposalModal &&
                                            a.status ===
                                              BondInsuranceAnalysisStatusEnum.approved
                                              ? 'Necessário informar o valor do seguro para habilitar o envio da carta de aprovação'
                                              : null
                                          }
                                          disabled={
                                            a.status !==
                                            BondInsuranceAnalysisStatusEnum.approved
                                          }
                                          trigger={
                                            <Button
                                              color={buttonColor as SemanticCOLORS}
                                              loading={isLoading}
                                              fluid
                                              disabled={!sendLetterEnabled}
                                              onClick={async () => {
                                                setIsLoading(true);
                                                try {
                                                  if (!hasChange)
                                                    await sendAnyLetter(a.id);
                                                  else {
                                                    await updateAnalysis(analysis);
                                                    await sendAnyLetter(a.id);
                                                  }
                                                  successNotification(
                                                    'Sucesso',
                                                    'Carta enviada!'
                                                  );
                                                  close();
                                                  callback();
                                                } catch (e) {
                                                  dangerNotification(
                                                    'Oops...',
                                                    'Ocorreu um erro ao enviar a carta'
                                                  );
                                                }
                                                setIsLoading(false);
                                              }}
                                            >
                                              {buttonText}
                                            </Button>
                                          }
                                        />
                                      </AuthorizationContainer>
                                    )}
                                  {[
                                    BondInsuranceAnalysisStatusEnum.approved,
                                    BondInsuranceAnalysisStatusEnum.preapproved
                                  ].includes(a.status) && (
                                    <Dropdown
                                      upward
                                      trigger={
                                        <Button icon>
                                          <Icon name="ellipsis vertical" />
                                        </Button>
                                      }
                                      icon={null}
                                      direction="left"
                                      floating
                                    >
                                      <Dropdown.Menu>
                                        <AuthorizationContainer
                                          action={ActionEnum.send}
                                          feature={FeatureEnum.letters}
                                        >
                                          <Dropdown.Item
                                            text={buttonText}
                                            icon="print"
                                            onClick={async () => {
                                              setIsLoading(true);
                                              try {
                                                if (!hasChange) await sendAnyLetter(a.id);
                                                else {
                                                  await updateAnalysis(analysis);
                                                }
                                                successNotification(
                                                  'Sucesso',
                                                  'Carta enviada!'
                                                );
                                                close();
                                                callback();
                                              } catch (e) {
                                                dangerNotification(
                                                  'Oops...',
                                                  'Ocorreu um erro ao enviar a carta'
                                                );
                                              }
                                              setIsLoading(false);
                                            }}
                                          ></Dropdown.Item>
                                        </AuthorizationContainer>
                                        <AuthorizationContainer
                                          action={ActionEnum.download}
                                          feature={FeatureEnum.letters}
                                        >
                                          <Dropdown.Item
                                            text="Download da carta"
                                            icon="download"
                                            onClick={async () => {
                                              setIsLoading(true);
                                              try {
                                                await downloadLetter(a.id, tenant_name);
                                                successNotification(
                                                  'Sucesso',
                                                  'Download realizado com sucesso!'
                                                );
                                              } catch (e) {
                                                dangerNotification(
                                                  'Oops...',
                                                  'Ocorreu um erro ao realizar o download carta'
                                                );
                                              }
                                              setIsLoading(false);
                                            }}
                                          ></Dropdown.Item>
                                        </AuthorizationContainer>
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  )}
                                </>
                              )}
                            </RowButtons>
                            </Table.Cell>
                          </Table.Row>
                        </>
                      );
                    })}
                  </Table.Body>
                </Table>
                {((allRefused && bondInsurance.property.total_amount <= 5000) || !lenderInsuranceEnabled) && (
                  <OtherSolutionsBanner
                    setShowCapitalizationModal={() => {
                      setShowCapitalizationModal(true);
                      setRxternalOpenEditCapitalizationModal(true);
                    }}
                    lenderInsuranceEnabled={lenderInsuranceEnabled}
                    allRefused={allRefused && bondInsurance.property.total_amount <= 5000}
                  />
                )}
              </ConfirmationModalContent>

                {
                  <div
                    style={{ display: 'flex', justifyContent: 'end', marginTop: '16px' }}
                  >
                    {[
                      !user.role!.includes('ESTATE') &&
                        !isEstateQuotationUser && (
                        // <AuthorizationContainer action={ActionEnum.update} feature={FeatureEnum.analysis_value}>
                        <ButtonComponent
                          primary
                          loading={isLoading}
                          disabled={!canEdit}
                          style={{ width: '178px' }}
                          onClick={async () => {
                            setIsLoading(true);
                            const verifyEmptyValue = analysis.filter(
                              a =>
                                a.status === BondInsuranceAnalysisStatusEnum.approved &&
                                a.value === '0,00' &&
                                a.insurer.code.includes('PORTO')
                            );
                            if (isRequired && verifyEmptyValue.length > 0) {
                              warningNotification(
                                'Aviso',
                                `O valor da análise da ${verifyEmptyValue[0].insurer.name} deve ser preenchido.`
                              );
                              setIsLoading(false);
                              return;
                            }
                            try {
                              await updateAnalysis(analysis);
                              successNotification(
                                'Sucesso',
                                'Análises atualizadas com sucesso!'
                              );
                              callback();
                              setIsOpen(false);
                            } catch (e) {
                              dangerNotification(
                                'Oops...',
                                'Ocorreu um erro ao atualizar as análises'
                              );
                            } finally {
                              setIsLoading(false);
                            }
                          }}
                        >
                          <Icon name={'save'} />
                          Salvar
                        </ButtonComponent>
                        //</AuthorizationContainer>
                      )
                    ]}
                  </div>
                }
              </>
            );
          }}
        </Formik>
      </>
    );
  };

  const componentRef = useRef(null);

  const DetailsContent = () => {
    const DetailsTitle = ({ title }: { title: string }) => {
      return (
        <div style={{ marginTop: '32px' }}>
          <div
            style={{
              fontSize: '16px',
              fontWeight: 700,
              color: '#59249B',
              marginTop: '10px',
              borderBottom: '1px solid #59249B',
              paddingBottom: '8px'
            }}
          >
            {title}
          </div>
        </div>
      );
    };

    return (
      <>
        <PrintedContainer ref={componentRef}>
          <DetailsTitle title="Dados da apólice" />
          <Grid>
            <BondInsuranceMainInfoDetails
              bondInsurance={bondInsurance}
              insurersData={
                availableBrokersAndEstates.estates.find(
                  c => c.value.id === bondInsurance.estate?.id
                )?.value?.insurer_data
              }
              insurers={
                availableBrokersAndEstates.estates.find(
                  c => c.value.id === bondInsurance.estate?.id
                )?.value?.insurers
              }
            />
          </Grid>

          <DetailsTitle title="Dados do imóvel" />
          <Grid>
            <BondInsurancePropertyDetails bondInsurance={bondInsurance} hideTitle />
          </Grid>

          <DetailsTitle title="Dados do locatário" />
          <Grid>
            {bondInsurance.tenant_type === PersonTypesEnum.natural && (
              <BondInsuranceNaturalTenantDetails
                bondInsurance={bondInsurance}
                hideTitle
              />
            )}
            {bondInsurance.tenant_type === PersonTypesEnum.legal && (
              <BondInsuranceLegalTenantDetails bondInsurance={bondInsurance} hideTitle />
            )}
          </Grid>
        </PrintedContainer>
      </>
    );
  };

  const LogsContent = () => {
    return (
      <div style={{ marginTop: '32px' }}>
        <LogTable
          analysisID={bondInsuranceId}
          createdAt={bondInsurance.created_at}
          updatedAt={
            analysisFormData?.length > 0 &&
            analysisFormData.reduce((r, o) => (o.updated_at < r.updated_at ? o : r))
              ?.updatedAt
          }
        />
      </div>
    );
  };

  return (
    <Modal
      style={{ width: '95%', maxHeight: '95%' }}
      as={Form}
      open={isOpen}
      onOpen={open}
      onClose={close}
      trigger={trigger}
      actions={undefined}
    >
      <Modal.Header>
        <Grid.Row
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
        >
          <Grid.Column>
            <Icon name="shield" style={{ marginRight: '8px', color: '#59249B' }} />
            {header}
          </Grid.Column>
        </Grid.Row>
      </Modal.Header>
      <Modal.Content scrolling>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: '1rem'
          }}
        >
          <div style={{ display: 'flex' }}>
            <DisplayTab title="Resultados" tab="resultados" first={true} end={false} />
            <DisplayTab title="Detalhes" tab="detalhes" first={false} end={false} />
            <DisplayTab title="Logs" tab="logs" first={false} end={true} />
          </div>
          <div style={{ display: 'flex', gap: 4 }}>
            {displayTab === 'resultados' && (
              <>
                <GeneralReanalysisModal
                  bondInsurance={bondInsurance}
                  nominalTotalPremiumAmount={0}
                  callback={callback}
                  close={close}
                />
                <CancelModal
                  callback={callback}
                  bondInsurance={bondInsurance}
                  username={user.name}
                  property={property}
                  user_id={user.id}
                  estate_id={estate?.id || ''}
                  naturalTentant={naturalTentant}
                  closeModal={close}
                />
              </>
            )}
            {displayTab === 'detalhes' && (
              <ReactToPrint
                trigger={() => (
                  <ButtonComponent primary icon={'print'}>
                    <Icon name="print" /> Imprimir
                  </ButtonComponent>
                )}
                content={() => componentRef.current!}
              />
            )}
          </div>
        </div>

        {displayTab === 'resultados' && ResultsContent()}
        {displayTab === 'detalhes' && DetailsContent()}
        {displayTab === 'logs' && LogsContent()}
      </Modal.Content>
    </Modal>
  );
};

export default connect()(AnalysisProgressModal);
